module.exports = __webpack_public_path__ + "media/images/athletes/107-ee93b2050d8450690589ffde8028c6f5.png";